module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j7NrL"))).then(() => module.bundle.root('dJXJK'));